import { Box, LinearProgress, useTheme } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";

export function ComplianceCell(params: GridRenderCellParams<any, number>) {
  const compliance = params.value || 0;
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}
    >
      <LinearProgress
        variant="determinate"
        value={compliance}
        sx={{
          width: "100%",
          height: 8,
          borderRadius: 1,
          backgroundColor:
            theme.palette.mode === "light" ? "#E0E0E0" : "#333333",
          "& .MuiLinearProgress-bar": {
            background: `linear-gradient(to left, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} ${compliance}%)`,
            borderRadius: 0.6,
          },
        }}
      />
    </Box>
  );
}
